import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4ecnlfrq9x: FaireBrandEntity = {
  token: "b_4ecnlfrq9x",
  type: "brand",
  name: "Sockerbit",
  avatarUrl:
    "https://cdn.faire.com/fastly/d2519ad802ad889390701293960a1685ddd3c006c2f09130d8bd0407f55ba407.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/564c4902e4f01d2c523eb5ea4559eac591f07ab65baa165ff8837754fff350c7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d2519ad802ad889390701293960a1685ddd3c006c2f09130d8bd0407f55ba407.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/564c4902e4f01d2c523eb5ea4559eac591f07ab65baa165ff8837754fff350c7.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 96,
  rating: 4.9,
  reviewCount: 84,
  isTopShop: true,
  isInsider: true,
  description:
    "Ever since moving to the United States, we have found ourselves yearning for the deliciously sweet and sometimes salty Scandinavian candy that we love. In fact, whenever someone asked us what we missed most from home, it was a running joke between us to say simply: the candy. This intense craving for candy may not seem so dire, but many Scandinavians have an insatiable sweet tooth and take their candy very seriously. On Saturdays in Sweden, there is a tradition called Lördagsgodis - which translates to ’Saturday candy’ - where families head into their local sweet shops and load up on their once-weekly treats.\n\nIn March of 2010, we made the life-altering decision to sell everything we owned to open the very first Scandinavian candy store selling bulk candy in the US. When we opened the doors of Sockerbit, we were literally met by very emotional Swedish customers that had been longing for their beloved candy, and as more and more people have tried our candy for the first time, they too have discovered the unique and life-changing goodness of Scandinavian sweets. Over the past 12 years, what started as a single candy store in New York City has now expanded to a flourishing candy company based in Los Angeles with the online capacity to ship our sweets all over the United States and beyond.\n\nWe are so grateful you are here! \n\nxx,\nStefan and Florence",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:49.780Z",
    importedBy: "entity-db-cli",
  },
};
